var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 250,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F87C56",
    d: "M48 158.886h18v91H48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-349.999 91.36h227.176V17.924a.285.285 0 01.284-.284H-8.492V0h-114.047a17.944 17.944 0 00-17.923 17.923v55.799h-209.537V91.36zM-1.065 66.904h-72.229A17.631 17.631 0 01-90.905 49.29V24.838H41.25l.194 107.853h7.096V24.838H395.5v17.64H66.18V150.33H23.838l-.194-107.853h-96.91v6.787h89.672l1.041 108.549H66.18v17.639H-.024l-1.041-108.55zm-348.934 31.39h323.868l.118-6.912h-89.728V24.803h17.64v48.94H-8.07l-.722 42.189h-341.208V98.293z",
    fill: "#F87C56"
  })));
}
export default SvgIconPatternTwo;